export default __webpack_public_path__ + "media/images/logo-symbol-wordmark-398843c872aaf38c75be26ea275f59a6.svg";